var tinymceProps = {
    theme: 'modern',
    readonly: false,
    //keep_styles: false,
    //valid_elements: 'i,b,strong,em,u,mark,sub,sup,small,a',
    selector: 'textarea.tinymce',
    content_css: ['//fonts.googleapis.com/css?family=Roboto:400,100italic,100,300,300italic,400italic,700,700italic'],
    plugins: ['lists link table code paste image imagetools'],
    statusbar: false,
    menubar: false,
    toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | numlist bullist outdent indent | removeformat | link | table | code | image imagetools',
    element_format: 'html',
    branding: false,
    fix_list_elements: true,
    paste_data_images: true
};

if (document.getElementsByClassName('tinymce').length !== 0) {
    if (document.getElementsByClassName('admin').length !== 0) {
        var tinymceAdminProps = tinymceProps;
        tinymceAdminProps.plugins = ['lists link table code paste image imagetools mark'];
        tinymceAdminProps.toolbar = 'undo redo | bold italic underline | mark | alignleft aligncenter alignright | numlist bullist outdent indent | removeformat | link | table | code | image imagetools';
        tinymce.init(tinymceAdminProps);
    } else {
       tinymce.init(tinymceProps);
    }
}